import { Container, Graphics } from 'pixi.js';
import type { PublicPlayerAppearance } from '@push.io/shared';

const BASE_COLOR_MAP: Record<string, number> = {
  cosm_base_blue: 0x3b82f6,
  cosm_base_red: 0xef4444,
  cosm_base_green: 0x22c55e,
  cosm_base_yellow: 0xeab308,
  cosm_base_purple: 0xa855f7,
  cosm_base_white: 0xf0f0f0,
  cosm_base_orange: 0xf97316,
  cosm_base_pink: 0xec4899,
  cosm_base_cyan: 0x06b6d4,
  cosm_base_lime: 0x84cc16,
  cosm_base_coral: 0xf87171,
  cosm_base_teal: 0x14b8a6,
  cosm_base_indigo: 0x6366f1,
  cosm_base_violet: 0x8b5cf6,
  cosm_base_gold: 0xf59e0b,
  cosm_base_silver: 0x9ca3af,
  base_color_blue: 0x3b82f6,
  base_color_red: 0xef4444,
  base_color_green: 0x22c55e,
  base_color_yellow: 0xeab308,
  base_color_purple: 0xa855f7,
  base_color_orange: 0xf97316,
  base_color_pink: 0xec4899,
  base_color_cyan: 0x06b6d4,
  base_color_white: 0xf0f0f0,
  base_color_black: 0x222222,
};

function resolveColor(id: string | null | undefined): number {
  if (!id) return 0x3b82f6;
  return BASE_COLOR_MAP[id] ?? 0x3b82f6;
}

export class BaseCircleLayer {
  readonly container: Container;
  private gfx: Graphics;
  private currentColor: number = 0x3b82f6;
  private currentRadius: number = 0;
  private currentIsLocal: boolean = false;

  constructor() {
    this.container = new Container();
    this.gfx = new Graphics();
    this.container.addChild(this.gfx);
  }

  update(appearance: PublicPlayerAppearance | null, radius: number, isLocal: boolean): void {
    const color = resolveColor(appearance?.baseColorId);
    const needsRebuild = radius !== this.currentRadius;
    this.container.tint = color;
    if (!needsRebuild) return;

    this.currentColor = color;
    this.currentRadius = radius;
    this.currentIsLocal = isLocal;

    const g = this.gfx;
    g.clear();

    g.circle(0, 0, radius);
    g.fill({ color: 0xffffff, alpha: 0.9 });

  }

  setVisible(visible: boolean): void {
    this.container.visible = visible;
  }

  destroy(): void {
    this.gfx.clear();
    this.gfx.destroy();
    this.container.removeChildren();
  }
}
